import type { TutorAvailability } from '@brighterly/lib-core-types/discipline/types'
import type { ScopeMode } from '@shared/lib/scope'

import { useToast } from '@shared/lib/toast'
import { useCsRoutes } from '@shared/api'

import { useScheduleStore } from '../model/store'

import { useNuxtApp } from '#app'

export const useTutorAvailability = async (disciplineId: number, mode: ScopeMode): Promise<TutorAvailability | null> => {
  const { $axios } = useNuxtApp()

  const scheduleStore = useScheduleStore()
  const toast = useToast()

  const url = useCsRoutes('schedule.tutor-availability', {
    '[discipline_id]': disciplineId,
  })

  if (!url) {
    const message = 'Invalid request URL.'
    console.error(message)
    toast.error({
      title: 'Unexpected error',
      description: message,
    })
    return null
  }

  const isEnter = mode === 'enter'
  const requestId = scheduleStore.beginAvailability(disciplineId, mode)
  if (isEnter) scheduleStore.setLoading(true)

  try {
    const { data } = await $axios.get(url)

    const availability: TutorAvailability | null = data?.availability || null
    scheduleStore.settleAvailability(disciplineId, requestId, availability)

    return availability
  } catch (err: any) {
    console.error(err)
    scheduleStore.failAvailability(disciplineId, requestId)
    return null
  } finally {
    if (isEnter) scheduleStore.setLoading(false)
  }
}
